<template>
  <div>
    <el-container class="home-container">
      <el-container>
        <el-menu style="background: #304156;padding-right: 10px;text-align: left;" unique-opened router
                 text-color="rgb(191, 203, 217)" :collapse="isCollapse" id="menuItem">
          <el-menu-item index="/home/index">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/order/info">
            <i class="el-icon-s-order"></i>
            <span slot="title">工单管理</span>
          </el-menu-item>
          <el-menu-item index="/user/Recharge">
            <i class="el-icon-s-ticket"></i>
            <span slot="title">充值记录</span>
          </el-menu-item>
          <el-menu-item index="/assistant/Group">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">聊天助手</span>
          </el-menu-item>
        </el-menu>
        <el-container>
          <el-main>
            <el-row :gutter="20"
                    style="height: 50px;box-shadow:0 1px 4px rgba(0,21,41,.08);margin-top: -20px;padding: 15px;margin-left:-20px;margin-bottom:20px">
              <el-col :span="16" id="col-head1">
                <el-breadcrumb class="app-breadcrumb" separator="/">
                  <i :class="openMenuClass" style="margin-top: -7px; margin-right: 10px;float: left;cursor: pointer;"
                     @click="showMenuInfo()"></i>
                  <span id="breadcrumb">
							<el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
							<el-breadcrumb-item v-text="this.$router.currentRoute.name"></el-breadcrumb-item>
						</span>
                </el-breadcrumb>
              </el-col>
              <el-col :span="8" style="font-size: 14px;" id="col-head2">
                <b>到期时间：
                  <span>{{ userVersion.expireTime | formatDateTime }} </span>
                  <span id="pcHead">&nbsp;&nbsp;
                    <span id="baseName">({{ userVersion.basename }})</span>
                    <span>
                      <el-link type="success" @click="goRecharge()" style="margin:-5px 10px 0px 10px;font-size: 14px;">续费</el-link>
                    </span>
                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link">
                      {{ user.username }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="goWebUrl()">下载客户端</el-dropdown-item>
                        <el-dropdown-item command="logout" divided>注销</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </b>

                <el-dropdown @command="handleCommand2" trigger="click">
                    <span class="el-dropdown-link">
                      <i class="el-icon-user-solid" id="phoneHead" style="display: none;font-size: 20px;margin-left: 20px" ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">续费</el-dropdown-item>
                      <el-dropdown-item command="b" >下载客户端</el-dropdown-item>
                      <el-dropdown-item command="c"  divided>注销</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

              </el-col>

            </el-row>
            <keep-alive>
              <router-view v-if="this.$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!this.$route.meta.keepAlive"></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  mounted: function () {
    this.getUserVersion();
  },
  methods: {
    //初始化websocket
    initWebSocket(data) {
      const wsUri = "wss://sys.helloworlds.cn/apis/websocket/server/" + data.userid;
      this.websock = new WebSocket(wsUri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() { //连接建立之后执行send方法发送数据
      // let actions = {"用户账号": "admin"};
      // this.websocketsend(JSON.stringify(actions));
      console.log("连接成功");
    },
    websocketonerror() {//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) { //数据接收
      const redata = JSON.parse(e.data);
      this.responseData = redata;
    },
    websocketsend(Data) {//数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {  //关闭
      console.log('断开连接', e);
    },
    goWebUrl() {
      window.open("https://www.helloword.com.cn", "_blank");
    },
    showMenuInfo() {
      this.isCollapse = !this.isCollapse;
      if (this.openMenuClass == "el-icon-s-fold") {
        this.openMenuClass = "el-icon-s-unfold";
      } else {
        this.openMenuClass = "el-icon-s-fold";
      }
    },
    getUserVersion() {
      this.getRequest("/userVersion/getUserVersion").then(resp => {
        if (resp && resp.status == 200) {
          var data = resp.data;
          this.userVersion = data;
          this.initWebSocket(data);
        }
      })
    },
    goRecharge() {
      this.$router.push({path: '/user/rechargePage'});
    },
    logout(_this){
      this.$confirm('注销登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.getRequest("/logout");
        _this.$store.commit('logout');
        _this.$router.replace({path: '/'});
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    handleCommand(cmd) {
      let _this = this;
      if (cmd == 'logout') {
        this.logout(_this);
      }
    },
    handleCommand2(cmd) {
      if(cmd === "a"){
        this.goRecharge();
      }else if(cmd === "b"){
        this.goWebUrl();
      }else if(cmd === "c"){
        let _this = this;
        this.logout(_this);
      }
    }
  },
  data() {
    return {
      userVersion: {
        basename: '',
        port: '',
        expireTime: '',
        userPorts: ''
      },
      isCollapse: false,
      openMenuClass: 'el-icon-s-fold'
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    routes() {
      return this.$store.state.routes
    }
  }
}
</script>
<style>



.home-container {
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

.home-header {
  background-color: #20a0ff;
  color: #333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: content-box;
  padding: 0px;
}

.home-aside {
  background-color: #304156;
}

.home-main {
  background-color: #fff;
  color: #000;
  text-align: center;
  margin: 0px;
  padding: 0px;;
}

.home_title {
  color: #fff;
  font-size: 22px;
  display: inline;
  margin-left: 8px;
}

.home_userinfo {
  color: #fff;
  cursor: pointer;
}

.home_userinfoContainer {
  display: inline;
  margin-right: 20px;
}

.el-submenu .el-menu-item {
  width: 180px;
  min-width: 175px;
}

.data-v-2c068d2b li {
  list-style-type: none;
  text-align: left;
  margin: 10px;
}

.data-v-2c068d2b {
  margin-left: -30px;
}

.data-v-2c068d2b span {
  float: right;
}

.data-v-2c068d2b i {
  float: right;
}

.el-icon-s-unfold:before {
  font-size: 30px;
}

.el-icon-s-fold:before {
  font-size: 30px;
}

@media screen and (max-width: 500px) {
  #phoneHead {
    display: block !important;
  }
  #pcHead{
    display: none;
  }

  .el-dialog__wrapper .el-dialog {
    width: 95% !important;
  }

  .el-menu--collapse {
    display: none;
  }

  .el-dialog__wrapper .el-dialog .el-dialog__body {
    overflow: auto
  }

  #breadcrumb, #baseName {
    display: none;
  }

  #col-head1 {
    width: 12%;
  }

  #col-head2 {
    width: 84%;
  }

  body {
    font-size: 12px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue